import React, { useState, useRef, useEffect } from 'react'
import ReCAPTCHA from 'react-google-recaptcha';
import HtmlParser from 'react-html-parser';
import {
    charactersRemainingGet, getError, getLanguageObj, getResponse, isUndNullEmpNew, LoadingSection, sendMessageCloseCurrentWindow, settings, styles,
    validateEmail
} from '../../helpers/UtilsHelper'
import { ContactService } from '../../services/contact/ContactService';
import Menu from '../main/Menu'
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const { app, company, firebase, icons, images, labels, messages, } = settings;
const { fields: dbFields, } = firebase?.firestore;
const { urls } = app?.backend;

const currentMethod = 'Contact - function';

export default function Contact({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '', reCaptchaToken: '' });
    const [errors, setErrors] = useState({ name: '', email: '', subject: '', message: '', recaptcha: '' });
    const charactersRemainingNumber = 400;
    const [charactersRemaining, setCharactersRemaining] = useState(``);
    const reCaptchaRef = useRef('');
    const [process, setProcess] = useState({ showLoading: false });
    const isMount = useRef(true);
    const [currentTheme, setCurrentTheme] = useState(document.documentElement.getAttribute('data-theme') || 'light');
    //#endregion variables

    //#region methods
    const setDefaultValue = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            setFormData({
                email: '',
                name: '',
                message: '',
                subject: '',
                reCaptchaToken: ''
            });
            reCaptchaRef.current.reset();

            setCharactersRemaining(
                charactersRemainingGet(
                    '',
                    charactersRemainingNumber,
                    `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    currentMethod
                )?.result
            );
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setFormDataFunc = async ({
        key = '',
        value = '',
        type = 0,
        e = null,
        subMethod = ''
    }) => {
        const currentMethod = 'setFormDataFunc';
        let response = getResponse({ type: 0 });
        try {
            switch (type) {
                case 0:
                    setFormData(prev => ({ ...prev, [key]: value }));
                    break;
                default:
                    break;
            }

            if (key === dbFields?.message) {
                setCharactersRemaining(
                    charactersRemainingGet(
                        e?.target?.value,
                        charactersRemainingNumber,
                        `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        currentMethod
                    )?.result
                );
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            await sendMessageCloseCurrentWindow({
                response: response,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const setErrosDefaultValue = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setErrosDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                name: '',
                email: '',
                subject: '',
                message: '',
                recaptcha: '',
            });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const formDataValidate = ({
        subMethod = '',
    }) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            const newErrors = {
                name: '',
                email: '',
                subject: '',
                message: '',
                recaptcha: '',
            };

            if (isUndNullEmpNew({ data: formData?.name, subMethod: currentMethod, })?.result) {
                newErrors.name = thisFieldRequired
                response.isWarning = true;
            }

            if (isUndNullEmpNew({ data: formData?.email, subMethod: currentMethod, })?.result) {
                newErrors.email = thisFieldRequired
                response.isWarning = true;
            } else if (!validateEmail(formData?.email)) {
                newErrors.email = messages?.youMustEnterValidEmail?.[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmpNew({ data: formData?.subject, subMethod: currentMethod, })?.result) {
                newErrors.subject = thisFieldRequired
                response.isWarning = true;
            }

            if (isUndNullEmpNew({ data: formData?.message, subMethod: currentMethod, })?.result) {
                newErrors.message = thisFieldRequired
                response.isWarning = true;
            }

            if (isUndNullEmpNew({ data: formData?.reCaptchaToken, subMethod: currentMethod, })?.result) {
                newErrors.recaptcha = messages?.pleaseAcceptTheCaptcha?.[languageObj?.id];
                response.isWarning = true;
            }

            setErrors(newErrors);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const sendInfo = async ({
        e = undefined,
        subMethod = '',
    }) => {
        const currentMethod = 'sendInfo';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            response = setErrosDefaultValue({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = formDataValidate({
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            setProcess(prev => ({ ...prev, showLoading: true }));

            response = await ContactService.sendMessage({
                formData: formData,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) {
                reCaptchaRef.current.reset();
                return response;
            }

            const responseTwo = setDefaultValue({
                subMethod: currentMethod,
            });
            if (!responseTwo.isSuccess || responseTwo.isWarning) {
                return responseTwo;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const onChangeRecaptcha = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'onChangeRecaptcha';
        let response = getResponse({ type: 0 });
        try {
            response = await setFormDataFunc({
                key: dbFields?.reCaptchaToken,
                value: reCaptchaRef?.current?.getValue(),
                type: 0,
                e: undefined,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return response;

            setErrors(prev => ({ ...prev, recaptcha: '' }));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            await sendMessageCloseCurrentWindow({
                response: response,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            response = setDefaultValue({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return response;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });

            await sendMessageCloseCurrentWindow({
                response: response,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation?.type === 'attributes' && mutation.attributeName === 'data-theme') {
                    setCurrentTheme(document.documentElement.getAttribute('data-theme'));
                }
            })
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme']
        });

        return () => {
            observer.disconnect();
        }
    }, [currentTheme]);
    //#endregion methods

    return (
        <div>
            <Menu viewName={'home'} process={'contact'} />

            <div className='content-wrapper bg-transparent'>

                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-12 col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.contact?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-12 col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.contact?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12 col-lg-6'>
                                <div className='card border-0 shadow-lg login-card mb-4'>
                                    <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.address?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.map} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.address?.[languageObj?.id]}</h5>
                                                    {/* <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                            <i className={`${icons?.fasFa?.cogs} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'><i className={icons?.fasFa?.minus} /></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body px-4 pb-4'>
                                        <p className='card-text'>
                                            {/* <img src={images?.logoCompany} alt='LogoCompany' style={{ width: 220, height: 'auto', maxWidth: '100%' }} /> */}
                                            <img src={images?.logoCHEJ} alt='LogoCompany' style={{ width: 100, height: 'auto', maxWidth: '100%' }} />
                                            <br />
                                            <b>{company?.name}</b>
                                            <br />
                                            {company?.slogan}
                                            <br />
                                        </p>
                                        <ul className='list-group' style={{ listStyle: 'none' }}>
                                            <li><i className={icons?.mapMarkedAlt} /> {company?.address}</li>
                                            <li><i className={icons?.mailBulk} /> {company?.zipCode}</li>
                                            <li><i className={icons?.globe} /> <a href={company?.url} target='_blank' rel='noreferrer'>{company?.url}</a></li>
                                        </ul>
                                        <p />
                                    </div>
                                </div>
                                <div className='card border-0 shadow-lg login-card mb-4'>
                                    <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.phones?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.smartphone} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.phones?.[languageObj?.id]}</h5>
                                                    {/* <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                            <i className={`${icons?.fasFa?.cogs} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'><i className={icons?.fasFa?.minus} /></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body px-4 pb-4'>
                                        <p className='card-text'>
                                        </p>
                                        <ul className='list-group' style={{ listStyle: 'none' }}>
                                            <li><i className={icons?.fasFa?.mobileAlt} /> {company?.phoneNumbers?.primary}</li>
                                            {/* <li><i className={icons?.fasFa?.mobileAlt} /> {company?.phoneNumber002}</li> */}
                                        </ul>
                                        <p />
                                    </div>
                                </div>
                            </div>
                            {/* /.col-md-6 */}
                            <div className='col-12 col-lg-6'>
                                <div className='card border-0 shadow-lg login-card mb-4'>
                                    <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.emails?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.email} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.emails?.[languageObj?.id]}</h5>
                                                    {/* <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                            <i className={`${icons?.fasFa?.cogs} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'><i className={icons?.fasFa?.minus} /></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body px-4 pb-4'>
                                        <p className='card-text'>
                                        </p><ul className='list-group' style={{ listStyle: 'none' }}>
                                            <li><i className={icons?.headset} /> <a href={`mailto:${company?.supportEmail}`}>{labels?.abbrevations?.supportDept?.[languageObj?.id]}</a></li>
                                            <li><i className={icons?.shoppingCart} /> <a href={`mailto:${company?.salesEmail}`}>{labels?.abbrevations?.salesDept?.[languageObj?.id]}</a></li>
                                            <li><i className={icons?.userTie} /> <a href={`mailto:${company?.administrationEmail}`}>{labels?.abbrevations?.administrationDept?.[languageObj?.id]}</a></li>
                                        </ul>
                                        <p />
                                    </div>
                                </div>
                                <div className='card border-0 shadow-lg login-card mb-4'>
                                    <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.socialNetworks?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.socialMedia} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.socialNetworks?.[languageObj?.id]}</h5>
                                                    {/* <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                            <i className={`${icons?.fasFa?.cogs} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'><i className={icons?.fasFa?.minus} /></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body px-4 pb-4'>
                                        <p className='card-text'>
                                        </p>
                                        <ul className='list-group' style={{ listStyle: 'none' }}>
                                            <li><a href={company?.contact?.socialNetworks?.whatsApp?.[languageObj?.id]} target='_blank' rel='noreferrer'><img src={images?.whatsApp} alt='WhatsAppIcon' style={{ ...styles_?.iconRRSS }} /> - WhatsApp</a></li>
                                            <li><a href={company?.contact?.socialNetworks?.telegram} target='_blank' rel='noreferrer'><img src={images?.telegram} alt='TelegramIcon' style={{ ...styles_?.iconRRSS }} /> - Telegram</a></li>
                                            <li><a href={company?.contact?.socialNetworks?.instagram} target='_blank' rel='noreferrer'><img src={images?.instagram} alt='InstagramIcon' style={{ ...styles_?.iconRRSS }} /> - Instagram</a></li>
                                            <li><a href={company?.contact?.socialNetworks?.facebook} target='_blank' rel='noreferrer'><img src={images?.facebook} alt='FacebookIcon' style={{ ...styles_?.iconRRSS }} /> - Facebook</a></li>
                                            <li><a href={company?.contact?.socialNetworks?.twitter} target='_blank' rel='noreferrer'><img src={images?.twitter} alt='TwitterIcon' style={{ ...styles_?.iconRRSS }} /> - Twitter</a></li>
                                        </ul>
                                        <p />
                                    </div>
                                </div>
                                <div className='card border-0 shadow-lg login-card mb-5'>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-body px-4 pb-4 pt-4'>
                                        <form onSubmit={(e) => sendInfo({ e: e, subMethod: 'onSubmit-form', })}>

                                            <div className='form-group'>
                                                <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                    {labels?.name?.[languageObj?.id]}
                                                </label>
                                                <div className='position-relative'>
                                                    <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                        maxLength={60}
                                                        placeholder={labels?.name?.[languageObj?.id]}
                                                        autoFocus
                                                        onChange={(e) => setFormDataFunc({
                                                            key: dbFields?.name,
                                                            value: e?.target?.value,
                                                            type: 0,
                                                            e: e,
                                                            subMethod: 'inputName',
                                                        })}
                                                        onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                                        value={formData?.name || ''}
                                                        tooltip='tooltip'
                                                        title={labels?.name?.[languageObj?.id]} />
                                                </div>
                                                <div className='form-text mt-1 form-error-text text-danger small'>{HtmlParser(errors?.name)}</div>
                                            </div>

                                            <div className='form-group'>
                                                <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                    {labels?.email?.[languageObj?.id]}
                                                </label>
                                                <div className='position-relative'>
                                                    <i className={`${icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                        maxLength={60}
                                                        placeholder={labels?.email?.[languageObj?.id]}
                                                        onChange={(e) => setFormDataFunc({
                                                            key: dbFields?.email,
                                                            value: e?.target?.value,
                                                            type: 0,
                                                            e: e,
                                                            subMethod: 'inputEmail',
                                                        })}
                                                        onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                        value={formData?.email || ''}
                                                        tooltip='tooltip'
                                                        title={labels?.email?.[languageObj?.id]}
                                                        type='email' />
                                                </div>
                                                <div className='form-text mt-1 form-error-text text-danger small'>{HtmlParser(errors?.email)}</div>
                                            </div>
                                            <div className='form-group'>
                                                <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                    {labels?.subject?.[languageObj?.id]}
                                                </label>
                                                <div className='position-relative'>
                                                    <i className={`${icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                        maxLength={60}
                                                        placeholder={labels?.subject?.[languageObj?.id]}
                                                        onChange={(e) => setFormDataFunc({
                                                            key: dbFields?.subject,
                                                            value: e?.target?.value,
                                                            type: 0,
                                                            e: e,
                                                            subMethod: 'inputSubject',
                                                        })}
                                                        onFocus={() => setErrors(prev => ({ ...prev, subject: '' }))}
                                                        value={formData?.subject || ''}
                                                        tooltip='tooltip'
                                                        title={labels?.subject?.[languageObj?.id]} />
                                                </div>
                                                <div className='form-text mt-1 form-error-text text-danger small'>{HtmlParser(errors?.subject)}</div>
                                            </div>
                                            <div className='form-group'>
                                                <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                    {labels?.message?.[languageObj?.id]}
                                                </label>
                                                <div className='position-relative'>
                                                    <i className={`${icons?.fasFa?.edit} position-absolute input-icon-left`} style={{ top: '25px', transform: 'none' }} />
                                                    <textarea className='form-control border-0 shadow-sm form-input-icon'
                                                        style={{ height: 'auto', paddingTop: '15px' }}
                                                        maxLength={charactersRemainingNumber}
                                                        placeholder={labels?.message?.[languageObj?.id]}
                                                        onChange={(e) => setFormDataFunc({
                                                            key: dbFields?.message,
                                                            value: e?.target?.value,
                                                            type: 0,
                                                            e: e,
                                                            subMethod: 'inputMessage',
                                                        })}
                                                        onFocus={() => setErrors(prev => ({ ...prev, message: '' }))}
                                                        rows={4}
                                                        value={formData?.message || ''}
                                                        tooltip='tooltip'
                                                        title={labels?.message?.[languageObj?.id]} />
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgInfo}>{HtmlParser(charactersRemaining)}</div>
                                                <div className='form-text mt-1 form-error-text text-danger small'>{HtmlParser(errors?.message)}</div>
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex justify-content-center mb-3'>
                                                    <ReCAPTCHA key={currentTheme}
                                                        className='text-center'
                                                        //hl='es-419'
                                                        // hl='en'
                                                        hl={languageObj?.id}
                                                        onChange={() => onChangeRecaptcha({ subMethod: 'reCaptcha', })}
                                                        ref={reCaptchaRef}
                                                        sitekey={app?.reCAPTCHA.reCaptchaV2SiteKey}
                                                        //sitekey={app?.reCAPTCHA.reCaptchaSiteKey}
                                                        theme={currentTheme}
                                                        size='normal' />
                                                </div>
                                                <div className='form-text mt-1 form-error-text text-danger small'>{HtmlParser(errors?.recaptcha)}</div>
                                            </div>
                                            <div className='form-group mt-4'>
                                                <button type='submit'
                                                    className='btn btn-primary btn-block shadow-sm font-weight-bold btn-primary'
                                                    disabled={process?.showLoading}
                                                    title={`${labels?.send?.[languageObj?.id]}`}
                                                    tooltip='tooltip' >
                                                    {!process?.showLoading ? (
                                                        <i className={`${icons?.fasFa?.paperPlane} mr-2`}></i>
                                                    ) : (
                                                        <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                    )} {labels?.send?.[languageObj?.id]}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className='text-muted text-center text-small'>
                                    <p>
                                        <small>
                                            {labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a target='_blank'
                                                href={app?.reCAPTCHA.urlPrivaciConditions}
                                                rel='noreferrer'>{labels?.privacyAndConditions?.[languageObj?.id]}
                                            </a>
                                        </small>
                                    </p>
                                </div>
                            </div>
                            {/* /.col-md-6 */}
                        </div> {/* /.row */}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}

const styles_ = {
    iconsContact: {
        width: '25px',
        height: '25px',
    },

    iconRRSS: {
        width: 20,
        height: 'auto',
        maxWidth: '100%',
    }
}